import { render } from "./RecipeView.vue?vue&type=template&id=7fa1c253&scoped=true"
import script from "./RecipeView.vue?vue&type=script&lang=js"
export * from "./RecipeView.vue?vue&type=script&lang=js"

import "./RecipeView.vue?vue&type=style&index=0&id=7fa1c253&scoped=true&lang=css"

import exportComponent from "C:\\Users\\stick\\projects\\recipe-project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fa1c253"]])

export default __exports__